import { createStyles, type StylesClasses } from '@utils/styles'

const styles = createStyles({
  cardContainer: {
    position: 'relative',
    border: '2px solid',
    borderColor: 'primary.main',
    borderRadius: '12px',
    padding: '32px',
    maxWidth: '500px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: {
      xs: '0.75rem',
      sm: '1.5rem',
    },
    height: 'fit-content',
  },
  popularBadge: {
    position: 'absolute',
    top: '-16px',
    left: '32px',
    backgroundColor: 'primary.main',
    color: '#fff',
    padding: '4px 16px',
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: '14px',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },

  textField: {
    input: {
      fontWeight: 600,
    },
  },
  savingsBox: {
    backgroundColor: '#F7F7F7',
    padding: '8px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '0.75rem',
  },

  discountBadge: {
    backgroundColor: '#E6F6EE',
    color: '#16A34A',
    fontWeight: 700,
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: '4px',
    display: 'inline-block',
    marginBottom: '8px',
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '2px',
  },

  guaranteeContainer: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'flex-start',
  },

  growthImageWrapper: {
    width: '24px',
    marginRight: '-4px',
  },
  growthImage: {
    width: '24px',
    height: '24px',
    marginTop: '4px',
  },

  trialChipIcon: {
    height: '8px',
    width: '8px',
    borderRadius: '50%',
    backgroundColor: 'custom.sectionTag',
  },

  trialChip: {
    fontWeight: 600,
    marginTop: '-4px',
  },

  leafImageWrapper: {
    width: '1rem',
  },

  policyBadgeWrapper: {
    width: {
      xs: '90px',
      sm: '56px',
    },
  },

  ctaButton: {
    minWidth: '100%',
    width: {
      xs: '100%',
      sm: 'unset',
    },
    fontSize: {
      xs: '0.8rem',
      sm: '1rem',
    },
  },
})

export default styles
export type StylesClassNames = StylesClasses<typeof styles>
